import { render } from "./edit-custom-form.vue?vue&type=template&id=18957afa&lang=html"
import script from "./edit-custom-form.vue?vue&type=script&lang=js"
export * from "./edit-custom-form.vue?vue&type=script&lang=js"

import "./edit-custom-form.vue?vue&type=style&index=0&id=18957afa&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__